
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 18.5H5a1.5 1.5 0 100 3h13a2.5 2.5 0 001.768-.732 2.5 2.5 0 000-3.536A2.5 2.5 0 0018 16.5H4a3.5 3.5 0 00-2.475 5.975A3.5 3.5 0 004 23.5h16a3.5 3.5 0 003.5-3.5L21.021 3.892A4 4 0 0017.068.5H6.932a4 4 0 00-3.953 3.392L.663 18.944","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    